export default __webpack_public_path__ + "static/media/crown.68ae049e.png";